import { render, staticRenderFns } from "./loginWithIOA.vue?vue&type=template&id=1b67ce53&scoped=true&"
import script from "./loginWithIOA.vue?vue&type=script&lang=ts&"
export * from "./loginWithIOA.vue?vue&type=script&lang=ts&"
import style0 from "./loginWithIOA.vue?vue&type=style&index=0&id=1b67ce53&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b67ce53",
  null
  
)

export default component.exports